import React from "react";
import InputMask from "react-input-mask";
import TextField, { TextFieldProps } from "@mui/material/TextField";
import { useTheme } from "@mui/material";
import { Control, Controller } from "react-hook-form";
import { tokens } from "../../theme";
import MaskedInput from "react-text-mask";

interface MaskedTextFieldProps
  extends Omit<TextFieldProps, "value" | "onChange"> {
  mask?: string;
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;

  //mui Textfield
  color?: "primary" | "secondary" | "success" | "error" | "info" | "warning";
  size?: "small" | "medium";
  label?: string | "";
  variant?: "filled" | "outlined" | "standard" | undefined;
  name: string;
  control: Control<any, any> 
  rules?:Object
  isDisabled?:boolean
  isEmpty?:boolean
}

const CustomMaskedTextField: React.FC<MaskedTextFieldProps> = ({
  mask,
  value,
  onChange,
  size,
  color,
  label,
  variant,
  name,
  control,
  rules,
  isDisabled,
  isEmpty,
  ...textFieldProps
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

    const isRequired = () => {
        if (rules && typeof rules === 'object' && 'required' in rules && label) {
            return true;
        }
        return false;
    };
    const getLabel = () => {
        if (isRequired()) {
            return (
            <span>
                {label}{" "}
                <span style={{ color: colors.success[200], fontSize: "18px" }}>
                  *
                </span>
              </span>
            );
        }
        return label;
    };
    
    const parseMask = (mask?: string): (string | RegExp)[] => {
      if (!mask) return []; 
      return mask.split("").map((char) => {
        if (char === "9") return /[0-9]/; 
        if (char === "A") return /[A-Za-z]/; 
        if (char === "*") return /[A-Za-z0-9]/; 
        return char; 
      });
    };
  
    const maskPattern = mask ? parseMask(mask) : ['(', /[0-9]/, /[0-9]/, /[0-9]/, ')', ' ', /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];

    return (
        <Controller
            name={name}
            control={control}
            rules={rules? rules: {}}
            render={({ field, fieldState }) => (
                <MaskedInput
                    mask={maskPattern}
                    value={isEmpty ? "" : value || field.value}
                    onChange={(e)=>{field.onChange(e); onChange &&onChange(e)}}
                    disabled={isDisabled}
                    render={(ref, inputProps) => {
                    const hasPlaceholder = Boolean(textFieldProps.placeholder);
                    return (
                        <TextField
                        {...inputProps}
                        inputRef={ref}
                        label={hasPlaceholder ? "" : (getLabel() || "")}
                        fullWidth
                        type="text"
                        size={size || "medium"}
                        color={color || theme.palette.mode === "dark" ? "secondary" : "primary"}
                        variant={variant || "outlined"}
                        InputLabelProps={{
                            shrink: hasPlaceholder ? false : (isDisabled ? true : Boolean(field.value)),
                        }}
                            error={!!fieldState.error}
                            helperText={fieldState.error ? fieldState.error.message : null}
                            {...textFieldProps}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                              '& fieldset': {
                                  borderColor: theme.palette.mode === "dark" ? '' : colors.primary[100],
                              },
                              '&.Mui-disabled': {
                                '& fieldset': {
                                    borderColor: isDisabled && theme.palette.mode === "light" ? colors.grey[300] : '', // Darker border for disabled state
                                },
                                '& input': {
                                    color: isDisabled && theme.palette.mode === "light" ? colors.grey[300] : '', // Darker text when disabled
                                },
                            },
                          },
                          '& .MuiInputBase-input.Mui-disabled': {
                            WebkitTextFillColor:isDisabled && theme.palette.mode === "light" ? colors.grey[300] : '' // Darker text for input when disabled
                        },
                          "& .MuiInputLabel-outlined": {
                              color: theme.palette.mode === "dark" ? '' : colors.primary[100],
                             '&.Mui-disabled': {
                                color:  isDisabled && theme.palette.mode === "light" ? colors.grey[300] : '', // Darker label for disabled state
                            },
                          }
                      }} 
                    />
                );
            }}
        />
            )}
        />
    );
};

export default CustomMaskedTextField;




